<template>
  <div class="pc-usdt-card">
    <div class="pc-usdt-title">充值币种</div>

    <div class="pc-usdt-currencies">
      <button type="button" class="pc-usdt-currency active">
        <span class="pc-usdt-logo">₮</span>
        <span>USDT</span>
      </button>
    </div>

    <div class="pc-usdt-tip">扫码或使用以下地址完成存款</div>

    <div class="pc-usdt-main">
      <div class="pc-usdt-qrcode-box">
        <div ref="qrcode" class="pc-usdt-qrcode"></div>
        <span v-if="!address" class="pc-usdt-empty">
          {{ loading ? '加载中' : '暂无地址' }}
        </span>
      </div>

      <div class="pc-usdt-minimum">
        <div>最小充值金额为：</div>
        <strong>{{ minimumAmount }} USDT</strong>
      </div>
    </div>

    <button type="button" class="pc-usdt-address" @click="copyAddress">
      <span>{{ address || '正在获取充值地址...' }}</span>
      <i class="pc-usdt-copy"><b></b><b></b></i>
    </button>

    <div class="pc-usdt-network">仅支持 TRC20 网络，请勿使用其他网络充值</div>

    <button type="button" class="pc-usdt-confirm" @click="confirmRecharge">我已充值</button>

    <div class="pc-usdt-notice">
      <div class="pc-usdt-notice-title"><span>i</span>温馨提示</div>
      <ul>
        <li><strong>收款地址定期更换，请勿保存作为长期使用</strong>，付款前请确认与系统展示是否一致。</li>
        <li>请勿向上述地址充值任何<strong>非选项中提供的网络协议和充值币种</strong>，否则资产将不可找回。</li>
        <li>您充值至上述地址后，需要整个网络节点的确认，2次网络确认后到账。</li>
        <li>请务必确认电脑及浏览器安全，防止信息被篡改或泄漏。</li>
      </ul>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';

export default {
  name: 'PcUsdtRechargeCard',
  props: {
    minPrice: {
      type: [String, Number],
      default: 10,
    },
  },
  data() {
    return {
      address: '',
      loading: false,
      qrcode: null,
    };
  },
  computed: {
    minimumAmount() {
      const value = Number(this.minPrice);
      return Number.isFinite(value) ? value.toFixed(2) : '10.00';
    },
  },
  created() {
    this.getRechargeAddress();
  },
  methods: {
    getRechargeAddress() {
      if (this.loading) return;
      this.loading = true;
      this.$apiFun
        .post('/api/user', {})
        .then(res => {
          if (Number(res.code) === 200) {
            const data = res.data || {};
            this.setAddress(data.wallet_address || '');
          } else {
            this.setAddress('');
            this.toast(res.message || '获取充值地址失败');
          }
        })
        .catch(error => {
          console.error('获取USDT充值地址失败：', error);
          this.setAddress('');
          this.toast('获取充值地址失败');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setAddress(value) {
      this.address = String(value || '').trim();
      this.$nextTick(this.renderQrcode);
    },
    renderQrcode() {
      const element = this.$refs.qrcode;
      if (!element) return;
      element.innerHTML = '';
      this.qrcode = null;
      if (!this.address) return;
      this.qrcode = new QRCode(element, {
        text: this.address,
        width: 116,
        height: 116,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      });
       this.$apiFun
        .post('/api/get/usdt/pay', { type: 'usdt-trc20' })
        .then(res => {
          if (Number(res.code) === 200) {
                          
          }
        });
    },
    copyAddress() {
      if (!this.address) {
        this.toast('暂无可复制的充值地址');
        return;
      }
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.address)
          .then(() => this.toast('复制成功！'))
          .catch(() => this.legacyCopy());
        return;
      }
      this.legacyCopy();
    },
    confirmRecharge() {
      if (!this.address) {
        this.toast('充值地址尚未加载完成');
        return;
      }
      this.toast('已提交，到账后系统将自动确认');
    },
    legacyCopy() {
      const input = document.createElement('input');
      input.value = this.address;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.toast('复制成功！');
    },
    toast(message) {
      if (this.$parent && typeof this.$parent.showTost === 'function') {
        this.$parent.showTost(message);
      }
    },
  },
  beforeDestroy() {
    if (this.$refs.qrcode) this.$refs.qrcode.innerHTML = '';
    this.qrcode = null;
  },
};
</script>

<style lang="scss" scoped>
.pc-usdt-card {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 18px 18px 16px;
  border-radius: 14px;
  background: #ffffff;
  color: #26324d;
}

.pc-usdt-title,
.pc-usdt-tip {
  font-size: 15px;
  line-height: 22px;
}

.pc-usdt-currencies {
  display: flex;
  gap: 18px;
  margin: 10px 0 17px;
}

.pc-usdt-currency {
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0 22px 0 12px;
  border: 1px solid #d7deea;
  border-radius: 23px;
  color: #71809d;
  background: #f8fafc;
  font-size: 16px;
}

.pc-usdt-currency.active {
  border-color: #3479ff;
  color: #ffffff;
  background: linear-gradient(135deg, #347fff, #316cf3);
  box-shadow: 0 6px 13px rgba(49, 108, 243, 0.28);
}

.pc-usdt-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  margin-right: 7px;
  border-radius: 50%;
  color: #ffffff;
  background: #27b897;
  font-size: 18px;
  font-weight: 700;
}

.pc-usdt-main {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.pc-usdt-qrcode-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 136px;
  height: 136px;
  border: 7px solid #f1f4f8;
  border-radius: 14px;
  background: #ffffff;
}

.pc-usdt-qrcode,
.pc-usdt-qrcode ::v-deep img,
.pc-usdt-qrcode ::v-deep canvas {
  display: block !important;
  width: 116px !important;
  height: 116px !important;
}

.pc-usdt-empty {
  position: absolute;
  color: #9aa5b8;
  font-size: 13px;
}

.pc-usdt-minimum {
  margin-left: 30px;
  color: #7b89a4;
  font-size: 15px;
  line-height: 25px;
}

.pc-usdt-minimum strong {
  display: block;
  color: #18b53f;
  font-size: 20px;
}

.pc-usdt-address {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  margin-top: 12px;
  padding: 0 18px;
  border: 1px solid #d7deea;
  border-radius: 24px;
  color: #26324d;
  background: #f9fbfe;
  text-align: left;
}

.pc-usdt-address > span {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  font-family: Consolas, monospace;
  font-size: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pc-usdt-copy {
  position: relative;
  width: 20px;
  height: 20px;
  margin-left: 10px;
}

.pc-usdt-copy b {
  position: absolute;
  width: 11px;
  height: 11px;
  border: 2px solid #77839d;
}

.pc-usdt-copy b:first-child {
  top: 1px;
  left: 1px;
}

.pc-usdt-copy b:last-child {
  right: 0;
  bottom: 0;
  background: #f9fbfe;
}

.pc-usdt-network {
  margin-top: 10px;
  color: #9aa5b8;
  font-size: 13px;
  text-align: center;
}

.pc-usdt-confirm {
  display: block;
  width: 220px;
  height: 44px;
  margin: 18px 0 0;
  border: 1px solid #3479ff;
  border-radius: 22px;
  color: #ffffff;
  font-size: 15px;
  background: linear-gradient(135deg, #3986ff, #316cf3);
  box-shadow: 0 6px 14px rgba(49, 108, 243, 0.25);
  cursor: pointer;
}

.pc-usdt-notice {
  box-sizing: border-box;
  width: 100%;
  margin-top: 18px;
  padding: 14px 17px 15px;
  border: 1px solid #edf0f5;
  border-radius: 12px;
  background: #fbfcfe;
}

.pc-usdt-notice-title {
  display: flex;
  align-items: center;
  color: #27334e;
  font-size: 14px;
  line-height: 22px;
}

.pc-usdt-notice-title span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  margin-right: 6px;
  border: 1px solid #53617c;
  border-radius: 50%;
  font-family: serif;
  font-size: 10px;
  line-height: 1;
}

.pc-usdt-notice ul {
  margin: 7px 0 0;
  padding-left: 23px;
  color: #27334e;
  font-size: 13px;
  line-height: 21px;
}

.pc-usdt-notice li + li {
  margin-top: 2px;
}

.pc-usdt-notice strong {
  color: #ff2d2d;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/deposit.vue